
(() => {
  const KEY = 'shopify_wishlist_v1';

  function getWishlist() {
    try {
      const data = JSON.parse(
        localStorage.getItem(KEY) || '[]'
      );
      return Array.isArray(data) ? data : [];
    } catch {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(
      KEY,
      JSON.stringify([...new Set(items)])
    );

    updateWishlistUI();

    window.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: { items: getWishlist() }
      })
    );
  }

  function updateWishlistUI() {
    const items = getWishlist();

    document.querySelectorAll('.wishlist-count')
      .forEach(counter => {
        counter.textContent = items.length;
        counter.hidden = items.length === 0;
      });

    document.querySelectorAll('[data-wishlist-handle]')
      .forEach(button => {
        const handle = button.dataset.wishlistHandle;
        const saved = items.includes(handle);

        button.classList.toggle('is-saved', saved);
        button.setAttribute('aria-pressed', String(saved));
        button.setAttribute(
          'aria-label',
          saved
            ? 'Elimină de la salvate'
            : 'Salvează produsul'
        );
      });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest(
      '[data-wishlist-handle]'
    );

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.wishlistHandle;
    if (!handle) return;

    const items = getWishlist();

    if (items.includes(handle)) {
      saveWishlist(items.filter(item => item !== handle));
    } else {
      saveWishlist([...items, handle]);
    }
  });

  document.addEventListener(
    'DOMContentLoaded',
    updateWishlistUI
  );

  window.addEventListener(
    'storage',
    updateWishlistUI
  );

  window.addEventListener(
    'pageshow',
    updateWishlistUI
  );

  window.ShopifyWishlist = {
    get: getWishlist,
    update: updateWishlistUI
  };
})();

(() => {
  const grid = document.getElementById('wishlist-page-grid');
  if (!grid) return;

  const empty = document.getElementById('wishlist-page-empty');
  const loading = document.getElementById('wishlist-page-loading');
  const count = document.getElementById('wishlist-page-count');

  const escapeHTML = value => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  async function renderWishlist() {
    const handles = window.ShopifyWishlist.get();

    grid.replaceChildren();
    loading.hidden = handles.length === 0;
    empty.hidden = true;
    count.textContent = handles.length === 1
  ? '1 produs salvat'
  : `${handles.length} produse salvate`;

    if (!handles.length) {
      loading.hidden = true;
      empty.hidden = false;
      return;
    }

    const root = window.Shopify?.routes?.root || '/';

    const products = await Promise.all(
      handles.map(async handle => {
        try {
          const response = await fetch(
            `${root}products/${encodeURIComponent(handle)}.js`
          );
          if (!response.ok) return null;
          return await response.json();
        } catch {
          return null;
        }
      })
    );

    products.forEach((product, index) => {
      if (!product) return;

      const handle = handles[index];
      const card = document.createElement('article');
      card.className = 'wishlist-page__card';

      const productUrl =
        `${root}products/${encodeURIComponent(handle)}`;

      const image = product.featured_image
        ? `<img src="${escapeHTML(product.featured_image)}"
             alt="${escapeHTML(product.title)}"
             loading="lazy">`
        : '';

      const price = new Intl.NumberFormat(
        document.documentElement.lang || 'ro-RO',
        {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'RON'
        }
      ).format(product.price / 100);

      card.innerHTML = `
        <a href="${escapeHTML(productUrl)}">
          ${image}
          <h3>${escapeHTML(product.title)}</h3>
        </a>
        <p>${escapeHTML(price)}</p>
        <div class="wishlist-page__actions">
          <a class="button" href="${escapeHTML(productUrl)}">
            Vezi produsul
          </a>
          <button type="button"
            class="wishlist-page__remove"
            data-wishlist-handle="${escapeHTML(handle)}">
            Elimină ♡
          </button>
        </div>
      `;

      grid.appendChild(card);
    });

    loading.hidden = true;

    if (!grid.children.length) {
      count.textContent = '0 produse disponibile';
      empty.hidden = false;
    }
  }

  window.addEventListener(
    'wishlist:updated',
    renderWishlist
  );

  renderWishlist();
})();
